var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "md:max-h-screen"
  }, [_c('h3', {
    staticClass: "my-15"
  }, [_vm._v("\n    Choix du modèle\n  ")]), _vm._v(" "), _vm.type === _vm.constants.CV_TYPES.BASIC ? _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-3 justify-center md:gap-x-10 gap-y-10 md:gap-y-0"
  }, [_c('div', {
    staticClass: "col-span-1 flex flex-col space-y-3.5"
  }, [_c('div', {
    staticClass: "relative cursor-pointer w-full",
    on: {
      "click": function ($event) {
        return _vm.checkModel('Basic');
      }
    }
  }, [_c('img', {
    staticClass: "object-scale-down",
    class: {
      'shadow-gray': _vm.model != 'Basic',
      'border-4 border-teal-600': _vm.model === 'Basic'
    },
    attrs: {
      "src": _vm.colors.Basic === 'yellow' ? '/assets/img/cv/cv_classic_1_yellow.png' : _vm.colors.Basic === 'pink' ? '/assets/img/cv/cv_classic_1_pink.png' : _vm.colors.Basic === 'teal' ? '/assets/img/cv/cv_classic_1_teal.png' : _vm.colors.Basic === 'orange' ? '/assets/img/cv/cv_classic_1_orange.png' : _vm.colors.Basic === 'gray' ? '/assets/img/cv/cv_classic_1_grey.png' : '/assets/img/cv/cv_classic_1_teal.png'
    }
  }), _vm._v(" "), _vm.model === 'Basic' ? _c('div', {
    staticClass: "absolute w-8 h-8 rounded-full flex justify-center items-center bg-teal-600 text-white -top-3 right-5"
  }, [_c('icon', {
    attrs: {
      "name": "checkmark"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex space-x-4 justify-center"
  }, [_c('checkbox-indigo', {
    attrs: {
      "name": "Basic-yellow",
      "value": _vm.colors.Basic === 'yellow',
      "color-border": "border-yellow-600",
      "color-checked": "bg-yellow-600",
      "color-unchecked": "bg-yellow-100",
      "not-click-to-false": true
    },
    on: {
      "input": function (newValue) {
        _vm.checkColor('Basic', 'yellow', newValue);
      }
    }
  }), _vm._v(" "), _c('checkbox-indigo', {
    attrs: {
      "name": "Basic-pink",
      "value": _vm.colors.Basic === 'pink',
      "color-border": "border-pink-600",
      "color-checked": "bg-pink-600",
      "color-unchecked": "bg-pink-100",
      "not-click-to-false": true
    },
    on: {
      "input": function (newValue) {
        _vm.checkColor('Basic', 'pink', newValue);
      }
    }
  }), _vm._v(" "), _c('checkbox-indigo', {
    attrs: {
      "name": "Basic-teal",
      "value": _vm.colors.Basic === 'teal',
      "color-border": "border-teal-600",
      "color-checked": "bg-teal-600",
      "color-unchecked": "bg-teal-100",
      "not-click-to-false": true
    },
    on: {
      "input": function (newValue) {
        _vm.checkColor('Basic', 'teal', newValue);
      }
    }
  }), _vm._v(" "), _c('checkbox-indigo', {
    attrs: {
      "name": "Basic-orange",
      "value": _vm.colors.Basic === 'orange',
      "color-border": "border-orange-600",
      "color-checked": "bg-orange-600",
      "color-unchecked": "bg-orange-100",
      "not-click-to-false": true
    },
    on: {
      "input": function (newValue) {
        _vm.checkColor('Basic', 'orange', newValue);
      }
    }
  }), _vm._v(" "), _c('checkbox-indigo', {
    attrs: {
      "name": "Basic-gray",
      "value": _vm.colors.Basic === 'gray',
      "color-border": "border-gray-600",
      "color-checked": "bg-gray-600",
      "color-unchecked": "bg-gray-100",
      "not-click-to-false": true
    },
    on: {
      "input": function (newValue) {
        _vm.checkColor('Basic', 'gray', newValue);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-1 flex flex-col space-y-3.5"
  }, [_c('div', {
    staticClass: "relative cursor-pointer w-full",
    on: {
      "click": function ($event) {
        return _vm.checkModel('Basic2');
      }
    }
  }, [_c('img', {
    staticClass: "object-scale-down",
    class: {
      'shadow-gray': _vm.model != 'Basic2',
      'border-4 border-teal-600': _vm.model === 'Basic2'
    },
    attrs: {
      "src": _vm.colors.Basic2 === 'yellow' ? '/assets/img/cv/cv_classic_2_yellow.png' : _vm.colors.Basic2 === 'pink' ? '/assets/img/cv/cv_classic_2_pink.png' : _vm.colors.Basic2 === 'teal' ? '/assets/img/cv/cv_classic_2_teal.png' : _vm.colors.Basic2 === 'orange' ? '/assets/img/cv/cv_classic_2_orange.png' : _vm.colors.Basic2 === 'gray' ? '/assets/img/cv/cv_classic_2_grey.png' : '/assets/img/cv/cv_classic_2_teal.png'
    }
  }), _vm._v(" "), _vm.model === 'Basic2' ? _c('div', {
    staticClass: "absolute w-8 h-8 rounded-full flex justify-center items-center bg-teal-600 text-white -top-3 right-5"
  }, [_c('icon', {
    attrs: {
      "name": "checkmark"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex space-x-4 justify-center"
  }, [_c('checkbox-indigo', {
    attrs: {
      "name": "Basic-yellow",
      "value": _vm.colors.Basic2 === 'yellow',
      "color-border": "border-yellow-600",
      "color-checked": "bg-yellow-600",
      "color-unchecked": "bg-yellow-100",
      "not-click-to-false": true
    },
    on: {
      "input": function (newValue) {
        _vm.checkColor('Basic2', 'yellow', newValue);
      }
    }
  }), _vm._v(" "), _c('checkbox-indigo', {
    attrs: {
      "name": "Basic-pink",
      "value": _vm.colors.Basic2 === 'pink',
      "color-border": "border-pink-600",
      "color-checked": "bg-pink-600",
      "color-unchecked": "bg-pink-100",
      "not-click-to-false": true
    },
    on: {
      "input": function (newValue) {
        _vm.checkColor('Basic2', 'pink', newValue);
      }
    }
  }), _vm._v(" "), _c('checkbox-indigo', {
    attrs: {
      "name": "Basic-teal",
      "value": _vm.colors.Basic2 === 'teal',
      "color-border": "border-teal-600",
      "color-checked": "bg-teal-600",
      "color-unchecked": "bg-teal-100",
      "not-click-to-false": true
    },
    on: {
      "input": function (newValue) {
        _vm.checkColor('Basic2', 'teal', newValue);
      }
    }
  }), _vm._v(" "), _c('checkbox-indigo', {
    attrs: {
      "name": "Basic-orange",
      "value": _vm.colors.Basic2 === 'orange',
      "color-border": "border-orange-600",
      "color-checked": "bg-orange-600",
      "color-unchecked": "bg-orange-100",
      "not-click-to-false": true
    },
    on: {
      "input": function (newValue) {
        _vm.checkColor('Basic2', 'orange', newValue);
      }
    }
  }), _vm._v(" "), _c('checkbox-indigo', {
    attrs: {
      "name": "Basic-gray",
      "value": _vm.colors.Basic2 === 'gray',
      "color-border": "border-gray-600",
      "color-checked": "bg-gray-600",
      "color-unchecked": "bg-gray-100",
      "not-click-to-false": true
    },
    on: {
      "input": function (newValue) {
        _vm.checkColor('Basic2', 'gray', newValue);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-1 flex flex-col space-y-3.5"
  }, [_c('div', {
    staticClass: "relative cursor-pointer w-full",
    on: {
      "click": function ($event) {
        return _vm.checkModel('Basic3');
      }
    }
  }, [_c('img', {
    staticClass: "object-scale-down",
    class: {
      'shadow-gray': _vm.model != 'Basic3',
      'border-4 border-teal-600': _vm.model === 'Basic3'
    },
    attrs: {
      "src": _vm.colors.Basic3 === 'yellow' ? '/assets/img/cv/cv_classic_3_yellow.png' : _vm.colors.Basic3 === 'pink' ? '/assets/img/cv/cv_classic_3_pink.png' : _vm.colors.Basic3 === 'teal' ? '/assets/img/cv/cv_classic_3_teal.png' : _vm.colors.Basic3 === 'orange' ? '/assets/img/cv/cv_classic_3_orange.png' : _vm.colors.Basic3 === 'gray' ? '/assets/img/cv/cv_classic_3_grey.png' : '/assets/img/cv/cv_classic_3_teal.png'
    }
  }), _vm._v(" "), _vm.model === 'Basic3' ? _c('div', {
    staticClass: "absolute w-8 h-8 rounded-full flex justify-center items-center bg-teal-600 text-white -top-3 right-5"
  }, [_c('icon', {
    attrs: {
      "name": "checkmark"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex space-x-4 justify-center"
  }, [_c('checkbox-indigo', {
    attrs: {
      "name": "Basic-yellow",
      "value": _vm.colors.Basic3 === 'yellow',
      "color-border": "border-yellow-600",
      "color-checked": "bg-yellow-600",
      "color-unchecked": "bg-yellow-100",
      "not-click-to-false": true
    },
    on: {
      "input": function (newValue) {
        _vm.checkColor('Basic3', 'yellow', newValue);
      }
    }
  }), _vm._v(" "), _c('checkbox-indigo', {
    attrs: {
      "name": "Basic-pink",
      "value": _vm.colors.Basic3 === 'pink',
      "color-border": "border-pink-600",
      "color-checked": "bg-pink-600",
      "color-unchecked": "bg-pink-100",
      "not-click-to-false": true
    },
    on: {
      "input": function (newValue) {
        _vm.checkColor('Basic3', 'pink', newValue);
      }
    }
  }), _vm._v(" "), _c('checkbox-indigo', {
    attrs: {
      "name": "Basic-teal",
      "value": _vm.colors.Basic3 === 'teal',
      "color-border": "border-teal-600",
      "color-checked": "bg-teal-600",
      "color-unchecked": "bg-teal-100",
      "not-click-to-false": true
    },
    on: {
      "input": function (newValue) {
        _vm.checkColor('Basic3', 'teal', newValue);
      }
    }
  }), _vm._v(" "), _c('checkbox-indigo', {
    attrs: {
      "name": "Basic-orange",
      "value": _vm.colors.Basic3 === 'orange',
      "color-border": "border-orange-600",
      "color-checked": "bg-orange-600",
      "color-unchecked": "bg-orange-100",
      "not-click-to-false": true
    },
    on: {
      "input": function (newValue) {
        _vm.checkColor('Basic3', 'orange', newValue);
      }
    }
  }), _vm._v(" "), _c('checkbox-indigo', {
    attrs: {
      "name": "Basic-gray",
      "value": _vm.colors.Basic3 === 'gray',
      "color-border": "border-gray-600",
      "color-checked": "bg-gray-600",
      "color-unchecked": "bg-gray-100",
      "not-click-to-false": true
    },
    on: {
      "input": function (newValue) {
        _vm.checkColor('Basic3', 'gray', newValue);
      }
    }
  })], 1)])]) : _vm.type === _vm.constants.CV_TYPES.DASHBOARD ? _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-y-5 md:justify-center w-full"
  }, [_c('div', {
    staticClass: "col-span-1 flex md:flex-col space-y-3.5 md:px-10"
  }, [_c('div', {
    staticClass: "w-full relative cursor-pointer",
    on: {
      "click": function ($event) {
        return _vm.checkModel('Dashboard');
      }
    }
  }, [_c('img', {
    staticClass: "object-scale-down",
    class: {
      'shadow-gray': _vm.model != 'Dashboard',
      'border-4 border-teal-600': _vm.model === 'Dashboard'
    },
    attrs: {
      "src": "/assets/img/cv/cv_dashboard.png"
    }
  }), _vm._v(" "), _vm.model === 'Dashboard' ? _c('div', {
    staticClass: "absolute bg-teal-600 text-white w-8 h-8 rounded-full flex justify-center items-center -top-3 right-5"
  }, [_c('icon', {
    attrs: {
      "name": "checkmark"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "space-x-4 justify-center hidden"
  }, _vm._l(_vm.modelColors.Dashboard, function (color, index) {
    return _c('checkbox-indigo', {
      key: `color_checkbox_${color}_${index}`,
      attrs: {
        "name": `Dashboard-${color}`,
        "value": _vm.colors.Dashboard === color,
        "color-border": `border-${color}-600`,
        "color-checked": `bg-${color}-600`,
        "color-unchecked": `bg-${color}-100`,
        "not-click-to-false": true
      },
      on: {
        "input": function (newValue) {
          _vm.checkColor('Dashboard', color, newValue);
        }
      }
    });
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-1 flex md:flex-col space-y-3.5 md:px-10"
  }, [_c('div', {
    staticClass: "relative cursor-pointer w-full",
    on: {
      "click": function ($event) {
        return _vm.checkModel('Dashboard2');
      }
    }
  }, [_c('img', {
    staticClass: "object-scale-down",
    class: {
      'shadow-gray': _vm.model != 'Dashboard2',
      'border-4 border-teal-600': _vm.model === 'Dashboard2'
    },
    attrs: {
      "src": "/assets/img/cv/cv_dashboard-2.png"
    }
  }), _vm._v(" "), _vm.model === 'Dashboard2' ? _c('div', {
    staticClass: "absolute bg-teal-600 text-white w-8 h-8 rounded-full flex justify-center items-center -top-3 right-5"
  }, [_c('icon', {
    attrs: {
      "name": "checkmark"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "space-x-4 justify-center hidden"
  }, _vm._l(_vm.modelColors.Dashboard, function (color, index) {
    return _c('checkbox-indigo', {
      key: `color_checkbox_${color}_${index}`,
      attrs: {
        "name": `Dashboard-${color}`,
        "value": _vm.colors.Dashboard === color,
        "color-border": `border-${color}-600`,
        "color-checked": `bg-${color}-600`,
        "color-unchecked": `bg-${color}-100`,
        "not-click-to-false": true
      },
      on: {
        "input": function (newValue) {
          _vm.checkColor('Dashboard', color, newValue);
        }
      }
    });
  }), 1)])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }